import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Languages } from "../../../../utils/apis/masters/masters";

library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData, minLength, maxLength } = useContext(Context);

  const id = props.show;

  const [data, setData] = useState();
  const [formData, setFormData] = useState({
    name: "",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const validationErrors = Validation.FormValidation({
  //     classname: ".countryclass",
  //   });

  //   if (validationErrors) {
  //     try {
  //       const response = await postData(`/masters/country/${id}`, formData);

  //       if (response.success) {
  //         setShowModal({ code: response.code, message: response.message });
  //         setTimeout(() => {
  //           setShowModal(0);
  //           props.handleClose();
  //         }, 1000);
  //       } else {
  //         setShowModal({ code: response.code, message: response.message });
  //         setTimeout(() => {
  //           setShowModal(0);
  //           props.handleClose();
  //         }, 1000);
  //       }
  //     } catch (error) {
  //       console.error("Error submitting form:", error);
  //     }
  //   }
  // };

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let errors = {};

    countLang.forEach((field) => {
      if (!formData[field.id]) {
        errors[field.id] = "Rider Partner name is required";
      } else {
        const trimmedName = formData[field.id].trim();

        if (trimmedName.length < minLength || trimmedName.length > maxLength) {
          errors[
            field.id
          ] = `rider partner name must be between ${minLength} and ${maxLength} characters`;
        }
      }
    });

    return errors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const response = await postData(`/masters/rider-help-type/${id}`, formData);
        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/masters/rider-help-type/${id}`);
    setFormData(response?.data);
    setData(response);
    getLanguges();
  };
 console.log(formData,"formData formData");
  useEffect(() => {
    GetEditData();
  }, []);

  const [countLang, setCountLang] = useState([]);

  const getLanguges = async () => {
    const response = await Languages();
    await setCountLang(response.data);
  };

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit Country</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Rider Help Type</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="countryclass"
                          >
                            {countLang?.map((data, index) => {
                              return (
                                <Row key={index}>
                                  <Col
                                    lg={8}
                                    md={10}
                                    className=" mx-auto Add-content"
                                  >
                                    <Row>
                                      <Col md={12}>
                                        <div className="main-form-section mt-5">
                                          <Row className="justify-content-center">
                                            <Form.Label column sm={3}>
                                            Rider Help Type Name {data?.name}
                                            </Form.Label>
                                            <Col sm={6}>
                                              <Form.Group>
                                                <InputGroup>
                                                  <Form.Control
                                                    type="text"
                                                    name={data.id}
                                                    value={formData[data.id]}
                                                    placeholder={`Enter country name in ${data?.name}`}
                                                    onChange={handleChange}
                                                    className="input-mandatory"
                                                    id="inputEmail3"
                                                  />{" "}
                                                  {errors[data.id] && (
                                                    <span style={errorStyle}>
                                                      {errors[data.id] +
                                                        " in " +
                                                        data.name}
                                                    </span>
                                                  )}
                                                  <span className="error-message"></span>
                                                </InputGroup>
                                              </Form.Group>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              );
                            })}

                            <Row className="mt-5 pb-3">
                              <div className="d-flex justify-content-center">
                                <Link>
                                  <CancelButton
                                    name={"cancel"}
                                    handleClose={props.handleClose}
                                  />
                                </Link>
                                <SaveButton
                                  name={"save"}
                                  handleSubmit={handleSubmit}
                                />
                              </div>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};
export default EditOffCanvance;
